import { useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { URL_LOGIN } from 'lib/router/url';
import { clearCredentials, getTokenExpirationTimeout, isTokenExpired } from 'lib/api';
import { Button } from 'modules/core/components/buttons';

// interface TokenExpiredModalProps {
//   token?: string
// }

const TokenExpiredModal = (props) => {
  const [show, setShow] = useState(false);
  const { token } = props;
  const location = useLocation();

  useEffect(() => {
    let timeout;

    if (!isTokenExpired(token)) {
      timeout = setTimeout(() => {
        clearCredentials();
        setShow(true);
      }, getTokenExpirationTimeout(token));
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [token]);

  return (
    <Modal
      show={ show }
      backdrop='static'
      aria-labelledby='token-expired-modal'
      centered
    >
      <Modal.Header>
        <Modal.Title>
          Внимание!
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col lg={ 12 }>
            Закончилось время вашей сессии. Войдите в систему заново.
          </Col>

          <Col lg={ { span: 4, offset: 4 } }>
            <Button
              className='button-margin text-margin'
              variant='primary'
              text='Войти'
              href={ `${ URL_LOGIN }?redirectTo=${ location.pathname }` }
              block
            />
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default TokenExpiredModal;
